module.exports = __webpack_public_path__ + "media/img/naked-logo-ccd7a9df689cf4180139965492e73440.png";